import { get, post } from '@/utils/request'



// ==================== 卷内目录相关接口 ====================
const CATALOG_BASE_URL = '/cmp-doc/data-project-catalog';

// 添加卷内目录
export const addCatalog = (params: any): Promise<any> => {
  return post(`${CATALOG_BASE_URL}/add`, params, {}, 'document')
}

// 修改卷内目录
export const updateCatalog = (params: any): Promise<any> => {
  return post(`${CATALOG_BASE_URL}/modify`, params, {}, 'document')
}

// 删除卷内目录
export const deleteCatalog = (catalogIds: any): Promise<any> => {
  return post(`${CATALOG_BASE_URL}/remove`, catalogIds, {}, 'document')
}

// 查询目录列表
export const getCatalogList = (params: any): Promise<any> => {
  return post(`${CATALOG_BASE_URL}/list`, params, {}, 'document')
}

// 列出卷内目录文档
export const listCatalogDocFile = (params: any): Promise<any> => {
  return post(`${CATALOG_BASE_URL}/list-catalog-doc-file`, params, {}, 'document')
}
